import InfoIcon from '@mui/icons-material/Info';
import * as styles from './ApplePrivateRelayBanner.css';

type Props = {
  onAddEmail: () => void;
};

export const ApplePrivateRelayBanner = ({ onAddEmail }: Props) => (
  <div className={styles.banner}>
    <div className={styles.left}>
      <InfoIcon className={styles.icon} />
      <span className={styles.text}>
        Add an email login method to prevent losing access.
      </span>
    </div>
    <button className={styles.button} onClick={onAddEmail}>
      Add email
    </button>
  </div>
);
